import React, { useState } from 'react';
import PasswordVisibility from '../../Common/PasswordVisibility';

function OiFormInput(props) {
    const [state, setState] = useState({ visible: false });

    const handlePasswordChange = () => {
        setState({ ...state, visible: !state.visible });
    };
    const renderVisiblePassword = (type, passwordVisibility) => {
        const { visible } = state;
        return type === 'password' && passwordVisibility ? (visible ? 'text' : 'password') : type;
    };

    const {
        labelClass,
        inputClass,
        name,
        type,
        label,
        hook,
        onChange,
        placeholder,
        required,
        inputValue,
        auto,
        error,
        passwordVisibility,
        checked,
        disable,
        reference,
        id
        // belongsToInvoice
    } = props;
    const { visible } = state;

    return (
        <div className={`oi-form__section`}>
            {/* <div className={`oi-form__section  ${belongsToInvoice ? '' : 'u-myt-022'}`}> */}
            <div className="oi-form__group">
                <div className="oi-form__associate">
                    <label className={labelClass} htmlFor={hook} style={{ display: label === undefined && 'none' }}>
                        {label}
                    </label>
                    <div className="u-relative-positioned">
                        <input
                            id={id !== undefined ? id : hook}
                            className={inputClass}
                            type={renderVisiblePassword(type, passwordVisibility)}
                            name={name}
                            onChange={onChange}
                            placeholder={placeholder}
                            required={required}
                            value={inputValue}
                            autoComplete={auto}
                            checked={checked}
                            disabled={disable}
                            ref={reference}
                        />

                        {passwordVisibility && (
                            <PasswordVisibility visible={visible} onPasswordChange={handlePasswordChange} />
                        )}
                        {props.children}
                    </div>
                    {error && <div className="oi-validation__container oi-validation__error">{error}</div>}
                </div>
            </div>
        </div>
    );
}

export default OiFormInput;
